import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import Image from "gatsby-image";
import Box from "reusecore/src/elements/Box";
import BlogPost from "../../../../../../packages/common/src/components/BlogPost/index.js";
import Text from "reusecore/src/elements/Text";
import Heading from "reusecore/src/elements/Heading";
import Button from "reusecore/src/elements/Button";
import FeatureBlock from "common/src/components/FeatureBlock";
import ParticlesComponent from "../particles";
import Container from "common/src/components/UI/Container";
import { Icon } from "react-icons-kit";
import { ic_arrow_forward } from "react-icons-kit/md/ic_arrow_forward";
import { BannerSquareShape, BannerCircleShape } from "../app.style";
import Card from "reusecore/src/elements/Card";
import {
  DiscountWrapper,
  DiscountLabel,
  ButtonWrapper,
  EmailInputWrapper
} from "./blogroll.style";

const DomainSection = ({
  SectionWrapper,
  row,
  col,
  title,
  description,
  button,
  image,
  imageArea,
  btnStyleTwo,
  newsPill,
  newsText
}) => {
  const Data = useStaticQuery(graphql`
    query {
      allContentfulBlogPost(limit: 20, filter: { body: { body: { ne: "" } } }) {
        edges {
          node {
            id
            slug
            title
            body {
              childMarkdownRemark {
                html
              }
            }
          }
        }
      }
    }
  `);

  return (
    <Box {...SectionWrapper}>
      <Container>
        {Data.allContentfulBlogPost.edges.map(blogPost => (
          <Card style={{ padding: 20, marginBottom: 60 }}>
            <BlogPost
              title={blogPost.node.title}
              content={blogPost.node.body.childMarkdownRemark.html}
            />
          </Card>
        ))}
      </Container>
    </Box>
  );
};

DomainSection.propTypes = {
  SectionWrapper: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  button: PropTypes.object,
  btnStyleTwo: PropTypes.object,
  newsPill: PropTypes.object,
  newsText: PropTypes.object,
  textArea: PropTypes.object
};

DomainSection.defaultProps = {
  SectionWrapper: {
    as: "section",
    pt: "80px",
    pb: "80px",
    overflow: "hidden"
  },
  row: {
    flexBox: true,
    flexWrap: "wrap",
    ml: "-15px",
    mr: "-15px",
    alignItems: "center"
  },
  imageAreaRow: {
    flexDirection: "row-reverse"
  },
  col: {
    pr: "15px",
    pl: "15px",
    width: ["100%", "100%", "50%", "44%", "44%"],
    mt: "-80px"
  },
  imageArea: {
    width: ["0%", "0%", "43%", "35%", "40%"],
    ml: "auto"
  },
  title: {
    content: "Article Title",
    fontSize: ["13px", "15px", "15px", "24px", "30px"],
    fontWeight: "300",
    color: "#0f2137",
    letterSpacing: "-0.01px",
    mb: "20px"
  },
  description: {
    content:
      "A mobile app landing page is important and  essential for right amount of information about your product. Start increasing your user base upon the launch of your product.",
    fontSize: "16px",
    color: "#343d48",
    lineHeight: "33px",
    mb: "10px"
  },
  button: {
    type: "button",
    minWidth: "156px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#fff",
    borderRadius: "4px",
    pl: "22px",
    pr: "22px",
    colors: "primaryWithBg"
  },
  image: {
    ml: "auto",
    mt: "70px"
  },
  btnStyleTwo: {
    minWidth: "156px",
    ml: "15px",
    bg: "#fff",
    color: "#00B0EA"
  },
  textArea: {
    width: ["100%", "100%", "50%", "55%", "55%"]
  },
  newsPill: {
    content: "Update",
    fontSize: "14px",
    fontWeight: "600",
    color: "#fff",
    mb: 0,
    as: "span",
    mr: "0.4em",
    bg: "#00B0EA"
  },
  newsText: {
    content: "ICR integration is now live!",
    fontSize: "13px",
    fontWeight: "400",
    color: "#0f2137",
    mb: 0,
    as: "span",
    ml: "10px"
  }
};

export default DomainSection;
